import { __extends } from "tslib";
import { TypeMetadata } from './TypeMetadata';
import { PropertyMetadata } from './PropertyMetadata';
import { MetadataBase } from './MetadataBase';
var ClassMetadata = /** @class */ (function (_super) {
    __extends(ClassMetadata, _super);
    function ClassMetadata(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        /**
         * All properties.
         */
        _this.properties = [];
        /**
         * Properties excluding child objects and lists.
         */
        _this.simpleProperties = [];
        /**
         * Properties containing child object types.
         */
        _this.childObjectProperties = [];
        /**
         * Properties containing child list types.
         */
        _this.childListProperties = [];
        return _this;
    }
    ClassMetadata.prototype.loadMetaData = function (schema, cache) {
        _super.prototype.loadFromSchema.call(this, schema);
        for (var propertyKey in schema.properties) {
            var propertySchema = schema.properties[propertyKey];
            var propertyMetaData = new PropertyMetadata(propertyKey, TypeMetadata.create(propertySchema, cache));
            propertyMetaData.loadFromSchema(propertySchema);
            if (propertyMetaData.type.basicType !== "unknown") {
                this.properties.push(propertyMetaData);
                if (propertyMetaData.type.basicType === "array") {
                    this.childListProperties.push(propertyMetaData);
                }
                else if (propertyMetaData.type.basicType === "object") {
                    this.childObjectProperties.push(propertyMetaData);
                }
                else {
                    this.simpleProperties.push(propertyMetaData);
                }
            }
        }
    };
    ClassMetadata.prototype.clone = function () {
        var clone = new ClassMetadata(this.name);
        clone.properties = this.properties;
        clone.simpleProperties = this.simpleProperties;
        clone.childObjectProperties = this.childObjectProperties;
        clone.childListProperties = this.childListProperties;
        return clone;
    };
    return ClassMetadata;
}(MetadataBase));
export { ClassMetadata };
